import * as React from 'react';
import { connect } from 'react-redux';
import './PersonalInsurance.css';
import './PolicyDetails/PolicyDetails.css';
import { optionalExtras } from '../../interfaces/Sales/optionalExtraInterface';
import '../../Sprite.css'

class OptionalExtraTile extends React.PureComponent<optionalExtras, any> {

    constructor(props) {
        super(props);

        this.handleOptionalExtra = this.handleOptionalExtra.bind(this);
    }

    async handleOptionalExtra() {
        if (this.props.hasVAP) {
            this.props.removeItem(this.props.id)
        }
        else {
            this.props.addItem(this.props.id)
        }
    }

    public render() {
        return (
            <>
                <div className="row noma" id={this.props.productName.replace("/ /g", "").replace("/'/g", "")}>
                    <div className="col-8 col-sm col-lg nopa">
                        <div className="text-left">
                            <div className="row noma align-items-center">
                                <div className={this.props.imageClass + ' mr-20px'}></div>
                                <div className="col-lg col nopa align-self-center">
                                    <p className="productName mb-0px">{this.props.productName}</p>
                                    {(this.props.canUse && !this.props.isAccessory) && this.props.hasVAP &&
                                        <p className="InsValue insValue-mobile nopa mb-0px font-weight-bold">{this.props.cost}</p>
                                    }
                                    {(this.props.canUse && this.props.isAccessory) && this.props.hasVAP &&
                                        <p className="InsValue insValue-mobile nopa mb-0px font-weight-bold">Insured for <br />{this.props.cost}</p>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.isAccessory && !this.props.canUse &&
                        <div className="nopa col mt-13px text-right">
                            <p className="InsValue font-weight-bold">Insured for {this.props.cost}</p>
                        </div>
                    }
                    {this.props.isAccessory && this.props.canUse &&
                        <div className="col-lg col-sm col nopa text-right text-lg-right">
                            {this.props.hasVAP &&
                                <>
                                    <div className="d-none d-lg-block noma nopa">
                                        <div className="row noma nopa">
                                            <p className="InsValue insValue-desktop nopa mb-0px font-weight-bold col">Insured for {this.props.cost}</p>
                                            <button className={"btn btn-outline-red align-self-center removeVapHeight col"} type="button" onClick={this.handleOptionalExtra}><a>Update/<br />Remove</a></button>
                                        </div>
                                    </div>
                                    <div className="d-block d-lg-none noma nopa">
                                        <div className="noma nopa">
                                            <p className="InsValue insValue-desktop nopa mb-0px font-weight-bold col">Insured for {this.props.cost}</p>
                                            <button className={"btn btn-outline-red align-self-center removeVapHeight col"} type="button" onClick={this.handleOptionalExtra}><a>Update/<br />Remove</a></button>
                                        </div>
                                    </div>
                                </>
                            }
                            {!this.props.hasVAP &&
                                <button className={"btn btn-solid-green align-self-center"} type="button" onClick={this.handleOptionalExtra}>Add</button>
                            }
                        </div>
                    }
                    {!this.props.canUse && !this.props.isAccessory &&
                        <div className="nopa col mt-13px text-right">
                            <p className="InsValue font-weight-bold">{this.props.cost}</p>
                        </div>
                    }
                    {(this.props.canUse && !this.props.isAccessory) &&
                        <div className="col-lg col-sm col nopa text-right text-lg-right">
                            {this.props.hasVAP &&
                                <>
                                    <div className="d-none d-lg-block noma nopa">
                                        <div className="row noma nopa">
                                            <p className="InsValue insValue-desktop nopa mb-0px font-weight-bold col">{this.props.cost}</p>
                                            <button className="btn btn-outline-red align-self-center removeVapHeight col" type="button" onClick={this.handleOptionalExtra}><a>Update/<br />Remove</a></button>
                                        </div>
                                    </div>
                                    <div className="d-block d-lg-none noma nopa">
                                        <div className="noma nopa">
                                            <p className="InsValue insValue-desktop nopa mb-0px font-weight-bold col">{this.props.cost}</p>
                                            <button className="btn btn-outline-red align-self-center removeVapHeight col" type="button" onClick={this.handleOptionalExtra}><a>Update/<br />Remove</a></button>
                                        </div>
                                    </div>
                                </>
                            }
                            {!this.props.hasVAP &&
                                <button className={"btn btn-solid-green align-self-center"} type="button" onClick={this.handleOptionalExtra}>Add</button>
                            }
                        </div>
                    }
                </div>
                <hr className="vaps-hr-2px mt-8px" />
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(OptionalExtraTile)